import DebtManagement, { MobileDebtManagement } from './DebtManagement/DebtManagementContainer';
import Education, { MobileEducation } from './Education/EducationContainer';
import EmergencyFund, { MobileEmergencyFund } from './EmergencyFund/EmergencyFundContainer';
import { MobileGoalsSummary } from './GoalsSummary/GoalsSummaryContainer';
import HealthCare, { MobileHealthcare } from './HealthCare/HealthCareContainer';
import HomePurchase, { MobileHomePurchase } from './HomePurchase/HomePurchaseContainer';
import { INSURANCE_GOAL_TYPE } from './Insurance/InsuranceConstants';
import Insurance, { MobileInsurance } from './Insurance/InsuranceContainer';
import LargePurchase, { MobileLargePurchase } from './LargePurchase/LargePurchaseContainer';
import { RETIREMENT_GOAL_TYPE } from './Retirement/RetirementConstants';
import Retirement, { MobileRetirement } from './Retirement/RetirementContainer';
import {
  SUMMARY,
  EDUCATION_GOAL_TYPE,
  LARGE_PURCHASE_GOAL_TYPE,
  HOME_PURCHASE_GOAL_TYPE,
  EMERGENCY_FUND_GOAL_TYPE,
  HEALTHCARE_GOAL_TYPE,
  DEBT_MANAGEMENT_GOAL_TYPE,
} from './FinancialPlanConstants';

export const FINANCIAL_GOAL_TYPE_DICTIONARY = {
  [RETIREMENT_GOAL_TYPE]: Retirement,
  [EDUCATION_GOAL_TYPE]: Education,
  [HEALTHCARE_GOAL_TYPE]: HealthCare,
  [EMERGENCY_FUND_GOAL_TYPE]: EmergencyFund,
  [LARGE_PURCHASE_GOAL_TYPE]: LargePurchase,
  [INSURANCE_GOAL_TYPE]: Insurance,
  [HOME_PURCHASE_GOAL_TYPE]: HomePurchase,
  [DEBT_MANAGEMENT_GOAL_TYPE]: DebtManagement,
  [SUMMARY]: null,
};

export const MOBILE_FINANCIAL_GOAL_TYPE_DICTIONARY = {
  [SUMMARY]: MobileGoalsSummary,
  [RETIREMENT_GOAL_TYPE]: MobileRetirement,
  [LARGE_PURCHASE_GOAL_TYPE]: MobileLargePurchase,
  [HOME_PURCHASE_GOAL_TYPE]: MobileHomePurchase,
  [EMERGENCY_FUND_GOAL_TYPE]: MobileEmergencyFund,
  [HEALTHCARE_GOAL_TYPE]: MobileHealthcare,
  [DEBT_MANAGEMENT_GOAL_TYPE]: MobileDebtManagement,
  [EDUCATION_GOAL_TYPE]: MobileEducation,
  [INSURANCE_GOAL_TYPE]: MobileInsurance,
};

export const DEFAULT_SELECTION = SUMMARY;
